/* crst-home-fx.js — shared homepage FX (document-scoped).
   Extracted from crst-home.liquid's inline <script>. Runs once even if multiple
   sections include it. Does NOT contain the hero carousel (see crst-hero.liquid),
   the tab-switch or the fades — the shared homepage behaviors:
   scroll-reveal, count-up, rail arrows, compare slider, product-card ajax add-to-cart.
   All queries are document-scoped. */
(function(){
  if(window.__crstHomeFx)return;window.__crstHomeFx=1;

  function init(){

    /* ajax add-to-cart on product cards (document-delegated; M7 + M2.5 rails) */
    (function(){
      document.addEventListener('click',function(e){
        var btn=e.target.closest('[data-add-id]'); if(!btn) return;
        e.preventDefault();
        var id=btn.getAttribute('data-add-id'); if(!id) return;
        var orig=btn.textContent; btn.disabled=true; btn.textContent='Adding';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(j){ if(j.status){throw j;} btn.textContent='Added'; document.dispatchEvent(new CustomEvent('cart:refresh')); setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1400); })
          .catch(function(){ btn.textContent='Try again'; btn.disabled=false; setTimeout(function(){btn.textContent=orig;},2000); });
      });
    })();

    /* scroll reveal — fade up on enter, honors data-delay + reduced-motion */
    (function(){
      var els=document.querySelectorAll('.reveal'); if(!els.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)){
        els.forEach(function(el){ el.classList.add('in'); }); return;
      }
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) return;
          var d=en.target.getAttribute('data-delay'); if(d) en.target.style.transitionDelay=d+'ms';
          en.target.classList.add('in'); io.unobserve(en.target);
        });
      },{threshold:0.08,rootMargin:'0px 0px -6% 0px'});
      /* Anything at or near the first fold reveals immediately on load — the scroll gate
         (threshold + negative rootMargin) otherwise leaves a just-below-the-fold section
         (e.g. compare, on viewports where the hero fills the screen) blank for the first
         ~120px of scrolling, which reads as "the module didn't load". Same belt-and-
         suspenders idea as the count-up below. Deeper sections keep the scroll reveal. */
      var vh=window.innerHeight||document.documentElement.clientHeight||0;
      els.forEach(function(el){
        var r=vh?el.getBoundingClientRect():null;
        if(r && r.top<vh*1.2 && r.bottom>-40){
          var d=el.getAttribute('data-delay'); if(d) el.style.transitionDelay=d+'ms';
          el.classList.add('in');
        } else {
          io.observe(el);
        }
      });
    })();

    /* count-up on the aggregate stats — real SSR value remains for no-JS/crawlers.
       Mirrors crst-business: parse + pre-zero immediately so the real number never
       flashes before the element scrolls into view (only when reduced-motion is off + IO present). */
    (function(){
      var nums=document.querySelectorAll('[data-countup]'); if(!nums.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)) return;
      function fmt(v,dec){var s=dec?v.toFixed(dec):Math.round(v).toString();var p=s.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');return p.join('.');}
      function run(el){var info=el._cu;if(!info||el._cuRan)return;el._cuRan=true;var dur=1100,t0=null;function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1);var e=1-Math.pow(1-p,3);el.textContent=fmt(info.target*e,info.dec);if(p<1)requestAnimationFrame(step);else el.textContent=info.raw;}requestAnimationFrame(step);}
      var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting&&en.target._cu){run(en.target);io.unobserve(en.target);}});},{threshold:0.4});
      /* parse + pre-zero immediately so the SSR value never paints, then observe */
      nums.forEach(function(el){var raw=el.textContent.trim();var dec=(raw.split('.')[1]||'').length;var target=parseFloat(raw.replace(/,/g,''));if(isNaN(target))return;el._cu={raw:raw,dec:dec,target:target};el.textContent=fmt(0,dec);io.observe(el);});
      /* Belt-and-suspenders: a tall stat row may never reach the 0.4 ratio (or IO context reports innerHeight 0), leaving the SSR value pre-zeroed at 0. After first layout, run count-up for any stat already in view; the observer still handles the rest. */
      requestAnimationFrame(function(){var vh=window.innerHeight||document.documentElement.clientHeight||0;nums.forEach(function(el){if(!el._cu)return;var r=el.getBoundingClientRect();if(r.top<vh*0.94&&r.bottom>0){run(el);io.unobserve(el);}});});
    })();

    /* rail arrow paging (M7 best-sellers + M2.5 shop-by-feature) — right shown by default,
       left hidden until scrolled right; resets to start on tab switch. Drives every [data-rail-wrap]. */
    (function(){
      var smooth=(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches)?'auto':'smooth';
      function setup(wrap){
        var prev=wrap.querySelector('[data-rail-prev]'), next=wrap.querySelector('[data-rail-next]');
        var tabsSel=wrap.getAttribute('data-rail-tabs-for'), tabs=tabsSel?document.querySelector(tabsSel):null;
        var userScrolled=false;
        function active(){return wrap.querySelector('.rail-pane.active');}
        function ends(){
          var rail=active();
          if(!rail){ wrap.classList.remove('has-prev','has-next'); return; }
          if(!userScrolled && rail.scrollLeft>0){ try{rail.scrollLeft=0;}catch(e){} }
          var s=rail.scrollLeft, max=rail.scrollWidth-rail.clientWidth;
          var atStart=s<=2, atEnd=s>=max-2;
          wrap.classList.toggle('has-prev',!atStart && max>2);
          wrap.classList.toggle('has-next',!atEnd && max>2);
        }
        function by(dir){
          var rail=active(); if(!rail) return; userScrolled=true;
          var card=rail.querySelector('.pcard'); var amt=card?(card.offsetWidth+18)*2:rail.clientWidth*0.8;
          var before=rail.scrollLeft, max=rail.scrollWidth-rail.clientWidth;
          var target=Math.max(0,Math.min(before+dir*amt,max));
          rail.scrollBy({left:dir*amt,behavior:smooth});
          /* smooth scroll silently no-ops in some engines — jump if it didn't move, then recompute */
          setTimeout(function(){ if(Math.abs(rail.scrollLeft-before)<2 && Math.abs(target-before)>2){ try{rail.scrollLeft=target;}catch(e){} } ends(); },220);
        }
        if(prev)prev.addEventListener('click',function(){by(-1);});
        if(next)next.addEventListener('click',function(){by(1);});
        wrap.querySelectorAll('.rail-pane').forEach(function(p){
          p.addEventListener('scroll',ends,{passive:true});
          ['pointerdown','wheel','touchstart','keydown'].forEach(function(ev){ p.addEventListener(ev,function(){userScrolled=true;},{passive:true}); });
        });
        /* on tab switch: snap the newly-active pane back to start (hide left arrow), then recompute across the swap */
        if(tabs)tabs.addEventListener('click',function(){ var a=active(); if(a){ try{a.scrollLeft=0;}catch(e){} } requestAnimationFrame(ends); setTimeout(ends,60); setTimeout(ends,400); });
        window.addEventListener('resize',ends); window.addEventListener('load',ends); ends();
      }
      document.querySelectorAll('[data-rail-wrap]').forEach(setup);
    })();

    /* certified-vs-uncertified compare slider — drives every [data-compare] */
    (function(){
      document.querySelectorAll('[data-compare]').forEach(function(cmp){
        var handle=cmp.querySelector('[data-compare-handle]'), hint=cmp.querySelector('[data-compare-hint]'), dragging=false, pos=52;
        function set(p){ pos=Math.max(4,Math.min(96,p)); cmp.style.setProperty('--pos',pos+'%'); if(handle) handle.setAttribute('aria-valuenow',Math.round(pos)); }
        function fromX(x){ var r=cmp.getBoundingClientRect(); set((x-r.left)/r.width*100); }
        function down(e){ dragging=true; if(hint) hint.style.opacity=0; fromX((e.touches?e.touches[0]:e).clientX); e.preventDefault(); }
        function move(e){ if(!dragging) return; fromX((e.touches?e.touches[0]:e).clientX); }
        function up(){ dragging=false; }
        cmp.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
        cmp.addEventListener('touchstart',down,{passive:false}); window.addEventListener('touchmove',move,{passive:false}); window.addEventListener('touchend',up);
        if(handle) handle.addEventListener('keydown',function(e){
          var step=(e.key==='ArrowLeft'||e.key==='ArrowDown')?-4:((e.key==='ArrowRight'||e.key==='ArrowUp')?4:null);
          if(e.key==='Home'){ set(4); if(hint)hint.style.opacity=0; e.preventDefault(); return; }
          if(e.key==='End'){ set(96); if(hint)hint.style.opacity=0; e.preventDefault(); return; }
          if(step!==null){ set(pos+step); if(hint)hint.style.opacity=0; e.preventDefault(); }
        });
      });
    })();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();
